import { useParams } from 'react-router-dom';
import { TeamCropTemplatesTable } from '../components/templates/CropsTable';
import { TeamCapexResourcesTable } from '../components/templates/CapexesTable';
import { TeamInputResourcesTable } from '../components/templates/InputsTable';
import { useSetBreadcrumbEffect } from '../contexts/BreadcrumbContext';

const TeamResourcesView = ({ title, table: Table }) => {
  const { teamId } = useParams();
  // Use undefined to avoid overwriting breadcrumbs set by child components
  useSetBreadcrumbEffect(title ? [{ display: title }] : undefined, [title]);
  return <Table teamId={teamId} />;
};

export const TeamCropTemplatesView = () => {
  return (
    <TeamResourcesView title="Crop Templates" table={TeamCropTemplatesTable} />
  );
};

export const TeamCapexesView = () => {
  return <TeamResourcesView title="CapExes" table={TeamCapexResourcesTable} />;
};

export const TeamInputsView = () => {
  return <TeamResourcesView table={TeamInputResourcesTable} />;
};
